import React from 'react';
import { Paper, Button, Stack } from '@mui/material';

// The list of factors is defined here but could also be passed as a prop
const COMPARISON_FACTORS = [
	{ key: 'date', label: 'Date' },
	{ key: 'period', label: 'Period' },
	// { key: 'grossRent', label: 'Gross Rent' },
	// { key: 'advanceAmount', label: 'Advance Amount' },
	// { key: 'netPay', label: 'Net Pay' },
	// { key: 'ibr', label: 'IBR (%)' },
	// { key: 'discountFactor', label: 'Discount Factor' },
	// { key: 'interestExp', label: 'Interest Expense' },
	// { key: 'payment', label: 'Payment' },
	{ key: 'openLeaseLiability', label: 'Open Lease Liability' },
	{ key: 'closingLeaseLiability', label: 'Closing Lease Liability' },
	// { key: 'adjustment', label: 'Adjustment' },
];


export const FactorButtons = ({ selectedFactor, onFactorChange }) => {
	return (
		<Paper
			elevation={0}
			sx={{
				p: 1,
				borderRadius: '16px', // A modern, softly rounded container
				backgroundColor: (theme) =>
					theme.palette.mode === 'dark' ? 'grey.900' : 'grey.100',
			}}
		>
			<Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
				{COMPARISON_FACTORS.map((factor) => (
					<Button
						key={factor.key}
						onClick={() => onFactorChange(factor.key)}
						variant="text" // Base variant is text, we control styling with `sx`
						sx={{
							// --- Common styles for all buttons ---
							borderRadius: '12px', // Rounded corners for a "chip" look
							textTransform: 'none', // More modern than ALL CAPS
							fontWeight: 600,
							px: 2.5,
							py: 1,
							transition: 'all 0.3s ease',

							// --- Styles for the SELECTED button ---
							...(selectedFactor === factor.key
								? {
									color: '#fff',
									backgroundColor: 'primary.main',
									boxShadow: '0 4px 14px rgba(0, 118, 255, 0.35)',
									'&:hover': {
										backgroundColor: 'primary.dark',
										boxShadow: '0 6px 16px rgba(0, 118, 255, 0.4)',
									},
								}
								: // --- Styles for UNSELECTED buttons ---
								{
									color: 'text.secondary',
									backgroundColor: 'transparent',
									'&:hover': {
										backgroundColor: 'action.hover',
										transform: 'translateY(-2px)', // Adds a "lift" on hover
									},
								}),
						}}
					>
						{factor.label}
					</Button>
				))}
			</Stack>
		</Paper>

	);
};